import React, { useState } from "react";

export const ConfigurationContext = React.createContext();


export const ConfigurationProvider = ({ children }) => {

  const [appliedConfiguration, setAppliedConfiguration] = useState({});
  const [settings, setSettings] = useState(null);
  const [loadingIcon, setLoadingIcon] = useState("");

  return (
    <ConfigurationContext.Provider value={{appliedConfiguration, setAppliedConfiguration, settings, setSettings, loadingIcon, setLoadingIcon}}>
    {children}
  </ConfigurationContext.Provider>
  );
};
